import { get, httpDelete, post, put } from '../../utils/http';

export const fetchLeaveContracts = ({ accountId }) => get(`/accounts/${accountId}/leave-contracts`);

export const addLeaveContract = ({ accountId, ...params }) => post(`/accounts/${accountId}/leave-contracts`, params);

export const updateLeaveContract = ({ accountId, leaveContractId, ...params }) =>
  put(`/accounts/${accountId}/leave-contracts/${leaveContractId}`, params);

export const deleteLeaveContract = ({ accountId, leaveContractId }) =>
  httpDelete(`/accounts/${accountId}/leave-contracts/${leaveContractId}`);

export const fetchContractLeaves = ({ accountId, leaveContractId }) =>
  get(`/accounts/${accountId}/leave-contracts/${leaveContractId}/leaves`);

export const fetchEmployeeLeaveManagement = ({ accountId, employeeId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/leave/management`);

export const fetchEmployeeLeaveHistory = ({ accountId, employeeId, ledgerLimit, ledgerOffset }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/leave/history`, { ledgerLimit, ledgerOffset });

export const assignEmployeeLeaveContract = ({ accountId, employeeId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/contract`, body);

export const bulkAssignEmployeesLeaveContract = ({ accountId, ...body }) =>
  post(`/accounts/${accountId}/employees/leave/contract/bulk`, body);

export const updateEmployeeLeaveContractAssignment = ({ accountId, employeeId, assignmentId, ...body }) =>
  put(`/accounts/${accountId}/employees/${employeeId}/leave/contract/${assignmentId}`, body);

export const terminateEmployeeLeaveContractAssignment = ({ accountId, employeeId, assignmentId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/contract/${assignmentId}/terminate`, body);

export const changeEmployeeLeaveContract = ({ accountId, employeeId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/contract/change`, body);

export const yearResetEmployeeLeave = ({ accountId, employeeId, assignmentId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/contract/${assignmentId}/year-reset`, body);

export const payoutAllEmployeeLeaveBalances = ({ accountId, employeeId, assignmentId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/contract/${assignmentId}/payout-all`, body);

export const adjustEmployeeLeaveBalance = ({ accountId, employeeId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/adjustments`, body);

export const createEmployeeLeaveRecord = ({ accountId, employeeId, ...body }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/leave/records`, body);

// Cancelling a leave record lives on the payroll router now — see removeLeaveRecordForPayrollQuery in
// accounts-payroll.

export const fetchEmployeeLeaveExpectedPay = ({
  accountId,
  employeeId,
  accountContractV2LeaveId,
  startDate,
  endDate,
  durationHours,
  wageSource,
  includeShiftPayrollFields,
  shiftId,
  unbookingId,
  branchId
}) =>
  get(`/accounts/${accountId}/employees/${employeeId}/leave/expected-pay`, {
    accountContractV2LeaveId,
    startDate,
    endDate,
    durationHours,
    wageSource,
    includeShiftPayrollFields,
    shiftId,
    unbookingId,
    branchId
  });
